import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { getWebsocketUrl } from "../utils/api/util";

interface WebSocketEvent {
  health_check_id?: number;
  health_check_run_id?: number;
  action?: string;
  strategy_day_id?: number;
  date?: string;
  request_id?: number;
  status?: string;
}

interface GlobalContextType {
  latestEvent: WebSocketEvent | null;
  socketConnected: boolean | null;
}

interface GlobalProviderProps {
  children: ReactNode;
}

// Create the context
const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

// Provide the context
export function GlobalProvider({ children }: GlobalProviderProps) {
  const [latestEvent, setLatestEvent] = useState<WebSocketEvent | null>(null);
  const [socketConnected, setSocketConnected] = useState<boolean | null>(null);

  useEffect(() => {
    const socket = new WebSocket(getWebsocketUrl());
    setSocketConnected(true);

    // TODO: Send/re-send sesame
    // socket.onopen = () => {
    //   console.log("✅ WebSocket connected to", websocketUrl);

    //   // Send Sesame token for authentication
    //   const sesameToken = localStorage.getItem("sesame_token"); // or however you store it
    //   if (sesameToken) {
    //     socket.send(sesameToken);
    //   } else {
    //     console.warn("⚠️ No sesame token found, connection may fail auth.");
    //   }
    // };

    socket.onmessage = (event) => {
      const responseData = JSON.parse(event.data);
      console.log("MESSAGE RECEIVED: ", responseData);

      setLatestEvent(responseData);
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      // notifications.show({
      //   title: "Error occured!",
      //   message: STANDARD_ERROR_MESSAGE,
      //   color: "red",
      // });
    };

    socket.onclose = () => {
      console.warn("🔌 WebSocket disconnected");
      setSocketConnected(false);
      // Optional: try to reconnect automatically after a few seconds
      // setTimeout(() => {
      //   console.log("♻️ Reconnecting WebSocket...");
      //   window.location.reload(); // simplest reconnect method
      // }, 5000);
    };
    // Cleanup on unmount
    return () => {
      socket.close();
    };
  }, []);

  return (
    <GlobalContext.Provider value={{ latestEvent, socketConnected }}>
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobalContext() {
  const context = useContext(GlobalContext);

  if (context === undefined) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }

  return context;
}
